// Upper bound for the browser-side CBCT DICOM order validation. A large series
// (hundreds of slices) is read synchronously inside the wasm worker; if it has
// not settled by this point the upload falls back to unordered.
export const VALIDATION_TIMEOUT_MS = 120_000;
